var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramAlert40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,6 C4.65685286,6 6,4.65685414 6,3 C6,1.34314714 4.65685286,0 3,0 C1.34314714,0 0,1.34314714 0,3 C0,4.65685414 1.34314714,6 3,6 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4,3.75 C2.37443733,1.645715 4.258492,0 7,0 C9.741494,0 11.625558,1.64573 12.6,3.75 C12.8801773,4.355025 13.0666667,5.57284 13.0666667,6.25 C13.0666667,8.203885 13.0666667,10.703885 13.0666667,13.75 L14,16 L7,16 L0,16 L0.933333333,13.75 C0.933333333,10.701735 0.933333333,8.201735 0.933333333,6.25 C0.933333333,5.572845 1.119832,4.35502 1.4,3.75 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Features-and-Benefits",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(17.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFCC00",
    mask: "url(#mask-2)",
    points: "-2.14285714 -2.14285714 8.14285714 -2.14285714 8.14285714 8.14285714 -2.14285714 8.14285714"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,32 C21.6568529,32 23,30.6568529 23,29 C23,27.3431459 21.6568529,26 20,26 C18.3431459,26 17,27.3431459 17,29 C17,30.6568529 18.3431459,32 20,32 Z",
    id: "Stroke-4",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(13.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "-2.33333333 -2.5 16.3333333 -2.5 16.3333333 18.5 -2.33333333 18.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(13.000000, 8.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4,9.30681818 C2.37443827,7.29818393 4.25849387,5.72727273 7,5.72727273 C9.741494,5.72727273 11.625558,7.29819777 12.6,9.30681818 C12.8801773,9.88434157 13.0666667,11.0468018 13.0666667,11.6931818 C13.0666667,13.5582539 13.0666667,15.9446175 13.0666667,18.8522727 L14,21 L7,21 L0,21 L0.933333333,18.8522727 C0.933333333,15.9425652 0.933333333,13.5562016 0.933333333,11.6931818 C0.933333333,11.0468066 1.1198306,9.8843387 1.4,9.30681818 Z",
    id: "Stroke-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 2.86387977,
    x2: 7,
    y2: 0.000243409091,
    id: "Stroke-9",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.8298867,
    y1: 3.5514002,
    x2: 12.7747513,
    y2: 1.49129591,
    id: "Stroke-10",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.1701166,
    y1: 3.5514002,
    x2: 1.225252,
    y2: 1.49129591,
    id: "Stroke-11",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramAlert40);
export default __webpack_public_path__ + "static/media/pictogramAlert40.a022b9e7ca340f1dab41d81b42036dfd.svg";
export { ForwardRef as ReactComponent };